import React, { createContext, useContext, useState, ReactNode } from 'react';
import Notification from './notification';
import styles from './notification.module.css';
import { NotificationProps } from '../../types';

export interface NotificationContextType {
  addNotification: (data: Omit<NotificationProps, 'id'>) => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [notifications, setNotifications] = useState<NotificationProps[]>([]);

  const addNotification = (data: Omit<NotificationProps, 'id'>) => {
    const id = `${Date.now()}-${Math.random()}`;
    setNotifications((prev) => [...prev, { ...data, id }]);

    setTimeout(() => {
      setNotifications((prev) => prev.filter((notif) => notif.id !== id));
    }, 5000);
  };

  return (
    <NotificationContext.Provider value={{ addNotification }}>
      {children}
      <div className={styles['notification-container']}>
        {notifications.map((notif) => (
          <Notification
            key={notif.id}
            title={notif.title}
            message={notif.message}
            type={notif.type}
          />
        ))}
      </div>
    </NotificationContext.Provider>
  );
};

export const useNotification = (): NotificationContextType => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};
